<template>
  <div>
    <b-card style="margin:1%">
      <b-col style="margin:5px">
        <b-button @click.stop="createCard" variant="success">{{ $t('Add') }}</b-button>
      </b-col>
      <b-table small striped hover :items="accessCards" :fields="fields">
      </b-table>
    </b-card>
  </div>
</template>

<script>
import axiosInstance from '@/utils/api.js'

export default {
  props: {
    currentRow: null,
    userInfo: null
  },
  data () {
    return {
      groupsUser: [],
      fields: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'username', label: this.$i18n.t('Login'), sortable: true },
        { key: 'password', label: this.$i18n.t('Password'), sortable: true },
        { key: 'card_number', label: this.$i18n.t('Card number'), sortable: true }
      ]
    }
  },
  methods: {
    async createCard () {
      let tmp = {
        user_id: this.currentRow.user_id
      }
      let response = await axiosInstance.post('/users/access_card', tmp)
      if (response.data.error) {
        this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
      } else {
        this.$root.$emit('makeToasts')
      }
      this.$store.dispatch('Users/GET_ACCESS_CARDS', this.currentRow.user_id)
    }
  },
  computed: {
    accessCards () {
      return this.$store.getters['Users/ACCESS_CARDS']
    }
  },
  watch: {
    currentRow: function (val) {
      this.$store.dispatch('Users/GET_ACCESS_CARDS', val.user_id)
    }
  },
  mounted () {
    this.$store.dispatch('Users/GET_ACCESS_CARDS', this.currentRow.user_id)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/accessCards/main.vue